/** Frame comments: the comment popover, editor and mention menu. */
export default {
  // Editor and mentions
  mentionPlaceholder: "Type @ to mention an agent or frame…",
  agentCommentPlaceholder: "Add a comment for this agent…",
  mentionHeading: "Mention an agent or frame",
  noAgentsFound: "No agents found",

  // Task thread
  frameFallback: "Frame",
  authorYou: "You",
  authorSystem: "System",
  authorAgent: "Agent",

  // Popover
  untitled: "Untitled",
  voiceInput: "Voice input",
  send: "Send",
  sending: "Sending…",
} as const;
